import type React from 'react';
import { HEADER_LOGO_API, LOGIN_LOGO_API } from 'src/constants';

interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  type?: 'login' | 'header';
}

const Logo: React.FC<LogoProps> = ({ type, ...props }) => {
  const logoSrc = type === 'login' ? LOGIN_LOGO_API : HEADER_LOGO_API;
  return <img src={logoSrc} alt="Logo" style={{ maxWidth: 600, maxHeight: 600 }} {...props} />;
};

export default Logo;
